import React from "react";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(-1); // Change route if needed
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-10 rounded-xl shadow-xl text-center max-w-md w-full">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">🎉 Thank You!</h1>
        <p className="text-lg text-gray-600 mb-6">
          Your registration has been completed successfully.
        </p>
        <button
          onClick={handleBackToHome}
          className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-full shadow-md transition duration-200"
        >
          Add Another User
        </button>

        <button
          onClick={() => window.open("https://event.sopa.org/")}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-full shadow-md transition duration-200 ml-4"
        >
          Go To Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
